(function () {
    'use strict';

    angular
        .module('jotApp')
        .factory('ObjectMap', ObjectMap);

    ObjectMap.$inject = [];

    function ObjectMap() {


        var greenIcon = L.icon({
            iconUrl: 'content/images/green-marker.svg',
            iconSize: [38, 95]
        });
        var yellowIcon = L.icon({
            iconUrl: 'content/images/yellow-marker.svg',
            iconSize: [38, 95]
        });
        var orangeIcon = L.icon({
            iconUrl: 'content/images/orange-marker.svg',
            iconSize: [38, 95]
        });
        var redIcon = L.icon({
            iconUrl: 'content/images/red-marker.svg',
            iconSize: [38, 95]
        });
        var greyIcon = L.icon({
            iconUrl: 'content/images/grey-marker.svg',
            iconSize: [38, 95]
        });

        var service = {
            build:build,
            getMarkerIcon: getMarkerIcon,
            getMarkerIconHome: getMarkerIconHome
        };


        return service;

        function build(mapName){
            return L.map(mapName);
        }

        function getMarkerIcon(status, level) {
            if (!status)
                return greyIcon;
            if (level == 0)
                return greenIcon;
            if (level >= 1 && level < 4)
                return yellowIcon;
            if (level >= 4 && level < 10)
                return orangeIcon;
            else
                return redIcon;
        }

        function getMarkerIconHome(status) {
            if (!status)
                return redIcon;
            else
                return greenIcon;
        }

    }

})();
